const SINGLE_SOLUTION_PAGE_TYPE = "SingleSolution";
const SOLUTIONS_IN_CATEGORY_PAGE_TYPE = "categorySolutions";
const SOLUTIONS_HOME_PAGE_TYPE = "Home";
const SOLUTIONS_SEARCH_PAGE_TYPE = "Search";
module.exports = {
    SINGLE_SOLUTION_PAGE_TYPE,
    SOLUTIONS_IN_CATEGORY_PAGE_TYPE,
    SOLUTIONS_HOME_PAGE_TYPE,
    SOLUTIONS_SEARCH_PAGE_TYPE
};
